import Vue from 'vue'
import VueRouter from 'vue-router'
import CampaignEdit from '../pages/Campaigns/campaign-edit'
import CampaignShow from '../pages/Campaigns/CampaignShow'
import AutoCampaignEdit from '../pages/AutoCampaigns/AutoCampaignEdit'
import AutoCampaignShow from '../pages/AutoCampaigns/AutoCampaignShow'
import LoyaltyPoints from '../pages/LoyaltyPoints'
import NewMemberActivityReport from "../pages/Reports/NewMemberActivityReport";
import PinsReport from '../pages/Reports/PinsReport';
import CheckInReport from '../pages/Reports/CheckInReport';
import RedemptionReport from '../pages/Reports/RedemptionReport';
import CampaignPerformanceReport from '../pages/Reports/CampaignPerformanceReport';
import AutoconnectPerformanceReport from '../pages/Reports/AutoconnectPerformanceReport';
import UserPermissionsReport from '../pages/Reports/UserPermissionsReport';
import BudzReport from '../pages/Reports/BudzReport';
import MemberActivityReport from '../pages/Reports/MemberActivityReport';
import MemberStatusReport from '../pages/Reports/MemberStatusReport';
import ImpactReportIndex from '../pages/Reports/ImpactReport/Index'
import ImpactReport from '../pages/Reports/ImpactReport/Report'
import InquiryReport from '../pages/Reports/InquiryReport/Report'
import DeliverabilityReport from '../pages/Reports/DeliverabilityReport';
import SharingLinks from '../pages/MerchantSettings/SharingLinks'
import UsersIndex from '../pages/Users/UsersIndex'
import UsersEdit from '../pages/Users/UsersEdit'
import Program from '../pages/MerchantSettings/Program'
import CashRewardsProgram from '../pages/MerchantSettings/CashRewardsProgram'
import SpenceLanding from '../pages/MerchantSettings/SpenceLanding'
import MerrcoLanding from '../pages/MerchantSettings/MerrcoLanding'
import SpringpayLanding from '../pages/MerchantSettings/SpringpayLanding'
import Passcode from '../pages/Passcode/Passcode'
import Stashboard from '../pages/Stashboard/Stashboard'
import Privacy from '../pages/Privacy/Privacy'
import Terms from '../pages/Terms/Terms'
import BrandsMarketplace from '../pages/BrandsMarketplace/BrandsMarketplace'
import Feedback from '../pages/Feedbacks/Feedback'
import StashboardSettings from "../pages/MerchantSettings/StashboardSettings";
import MemberOfferEdit from "../pages/MemberOffers/MemberOfferEdit"
import RewardEdit from "../pages/Rewards/RewardEdit";
import CampaignIndex from "../pages/Campaigns/CampaignIndex"
import CampaignCompare from "../pages/Campaigns/CampaignCompare";
import Audiences from "../pages/Audiences/Audiences";
import AudienceEdit from "../pages/Audiences/AudienceEdit";
import AudienceShow from "../pages/Audiences/AudienceShow";
import Insights from "../pages/Insights/Insight";
import InsightReport from "../pages/Insights/InsightReport";

import { beforeEach } from '@springbig/sb-components';

Vue.use(VueRouter)

const router =  new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/campaigns',
      name: 'CampaignIndex',
      component: CampaignIndex,
    },
    {
      path: '/campaigns/compare',
      name: 'CampaignCompare',
      component: CampaignCompare,
    },
    {
      path: '/campaigns/:id/edit',
      name: 'CampaignEdit',
      component: CampaignEdit
    },
    {
      path: '/campaigns/:id',
      name: 'CampaignShow',
      component: CampaignShow,
    },
    {
      path: '/classic_campaigns/:id/edit',
      name: 'ClassicCampaignEdit',
      component: CampaignEdit,
    },
    {
      path: '/classic_campaigns/:id',
      name: 'ClassicCampaignShow',
      component: CampaignShow
    },
    {
      path: '/auto_campaigns/:id/edit',
      name: 'AutoCampaignEdit',
      component: AutoCampaignEdit,
    },
    {
      path: '/auto_campaigns/:id',
      name: 'AutoCampaignShow',
      component: AutoCampaignShow,
      beforeEnter: (to, from, next) => {
        const routesToSkip = ['budz', 'start']
        if (!routesToSkip.includes(to.params.id)) { next() }
      }
    },
    {
      path: '/reports/new_member_activity',
      name: 'NewMemberActivityReport',
      component: NewMemberActivityReport,
    },
    {
      path: '/reports/pins',
      name: 'PinsReport',
      component: PinsReport,
    },
    {
      path: '/reports/check_in',
      name: 'CheckInReport',
      component: CheckInReport,
    },
    {
      path: '/reports/redemptions',
      name: 'RedemptionReport',
      component: RedemptionReport,
    },
    {
      path: '/reports/autoconnect_performance',
      name: 'AutoconnectPerformanceReport',
      component: AutoconnectPerformanceReport,
    },
    {
      path: '/reports/campaign_performance',
      name: 'CampaignPerformanceReport',
      component: CampaignPerformanceReport,
    },
    {
      path: '/reports/user_permissions',
      name: 'UserPermissionsReport',
      component: UserPermissionsReport,
    },
    {
      path: '/reports/budz',
      name: 'BudzReport',
      component: BudzReport,
    },
    {
      path: '/reports/member_activity',
      name: 'MemberActivityReport',
      component: MemberActivityReport,
    },
    {
      path: '/reports/member_status',
      name: 'MemberStatusReport',
      component: MemberStatusReport,
    },
    {
      path: '/reports/loyalty_points',
      name: 'LoyaltyPoints',
      component: LoyaltyPoints,
    },
    {
      path: '/reports/impact',
      name: 'ImpactReport',
      component: ImpactReportIndex,
    },
    {
      path: '/reports/impact/new',
      name: 'ImpactReportNew',
      component: ImpactReport,
    },
    {
      path: '/reports/impact/:id',
      name: 'ImpactReportShow',
      component: ImpactReport,
    },
    {
      path: '/reports/inquiry',
      name: 'InquiryReport',
      component: InquiryReport,
    },
    {
      path: '/reports/campaign_deliverability',
      name: 'DeliverabilityReport',
      component: DeliverabilityReport,
    },
    {
      path: '/merchants/:id/sharing',
      name: 'SharingLinks',
      component: SharingLinks,
    },
    {
      path: '/merchants/:id/program',
      name: 'Program',
      component: Program,
    },
    {
      path: '/merchants/:id/cash_rewards_program',
      name: 'CashRewardsProgram',
      component: CashRewardsProgram,
    },
    {
      path: '/merchants/:id/spence_landing',
      name: 'SpenceLanding',
      component: SpenceLanding,
    },
    {
      path: '/merchants/:id/merrco_landing',
      name: 'MerrcoLanding',
      component: MerrcoLanding,
    },
    {
      path: '/merchants/:id/springpay_landing',
      name: 'SpringpayLanding',
      component: SpringpayLanding,
    },
    {
      path: '/merchants/:id/stashboard_settings',
      name: 'StashboardSettings',
      component: StashboardSettings,
    },
    {
      path: '/users',
      name: 'UsersIndex',
      component: UsersIndex
    },
    {
      path: '/users/:id/edit',
      name: 'UsersEdit',
      component: UsersEdit
    },
    {
      path: '/users/new',
      name: 'UsersNew',
      component: UsersEdit
    },
    {
      path: '/passcode/:id',
      name: 'Passcode',
      component: Passcode
    },
    {
      path: '/stashboard/:id',
      name: 'Stashboard',
      component: Stashboard,
      props: true
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms_conditions',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/brands_marketplace',
      name: 'BrandsMarketplace',
      component: BrandsMarketplace,
    },
    {
      path: '/insights',
      name: 'Insights',
      component: Insights
    },
    {
      path: '/insights/report/:id',
      name: 'InsightReport',
      component: InsightReport
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: Feedback
    },
    {
      path: '/member_offers/:id/edit',
      name: 'MemberOfferEdit',
      component: MemberOfferEdit
    },
    {
      path: '/rewards/:id/edit',
      name: 'RewardEdit',
      component: RewardEdit
    },
    {
      path: '/audiences',
      name: 'Audiences',
      component: Audiences
    },
    {
      path: '/audiences/new',
      name: 'AudienceCreate',
      component: AudienceEdit
    },
    {
      path: '/audiences/:id',
      name: 'AudienceShow',
      component: AudienceShow
    },
    {
      path: '/audiences/:id/edit',
      name: 'AudienceEdit',
      component: AudienceEdit
    }
  ]
});

router.beforeEach(beforeEach);

export default router
